import { $api } from "../generated/client";

export default function useGetCommentAttachmentPresignedUrl() {
	return $api.useMutation(
		"post",
		"/shops/{shopId}/return-requests/{returnRequestId}/comments/attachments/presigned-url",
		{
			onError(error) {
				console.error(error);
			},
		},
	);
}
